var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'div',{tag:"component",staticClass:"va-item align--center no-wrap",class:{'va-item--clickable': _vm.clickable || _vm.to},attrs:{"to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }